<style lang="scss">
  $mainColor: #00698d;
  .audit-header{
    position:fixed;
    height:65px;
    top:0;
    left:0;
    width:100%;
    padding:0 20px;
    background:#fff;
    z-index:100;
  }
  .urban-nav{
    position: relative;
    height:100%;
    width:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    .logo{
      font-size:0;
      text-indent: -9999px;
      width:55px;
      height:50px;
      background:url('../img/header-logo.png') no-repeat center top;
      background-size:auto 100%;
      a{
        display:block;
        height:100%;
        color:#595757;
      }
    }
    .hamburger-btn{
      width: 26px;
      height: 24px;
      position: absolute;
      right:20px;
      overflow:hidden;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: .5s ease-in-out;
      -moz-transition: .5s ease-in-out;
      -o-transition: .5s ease-in-out;
      transition: .5s ease-in-out;
      span{
        display: block;
        position: absolute;
        height: 3px;
        width: 100%;
        background: $mainColor;
        opacity: 1;
        left: 0;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
        &:nth-child(1) {
          top: 0px;
        }
        &:nth-child(2) {
          top: 10px;
        }
        &:nth-child(3) {
          top: 20px;
        }
      }
      &.active{
        span{
          &:nth-child(1) {
            top: 10px;
            -webkit-transform: rotate(135deg);
            -moz-transform: rotate(135deg);
            -o-transform: rotate(135deg);
            transform: rotate(135deg);
          }
          &:nth-child(2) {
            opacity: 0;
            left: -60px;
          }
          &:nth-child(3) {
            top: 10px;
            -webkit-transform: rotate(-135deg);
            -moz-transform: rotate(-135deg);
            -o-transform: rotate(-135deg);
            transform: rotate(-135deg);
          }
        }
        &.open{
          position:absolute;
          top:21px;
          right:20px;
          z-index:100;
        }
      }
    }
    .login-btn{
      width:40px;
      height:40px;
      font-size:12px;
      color:#fff;
      background:$mainColor;
      font-weight: bold;
      border-radius: 50%;
      position: absolute;
      left: 20px;
      top:50%;
      margin-top:-20px;
    }
    .logout-btn{
      width:40px;
      height:40px;
      font-size:12px;
      color:#fff;
      background:$mainColor;
      font-weight: bold;
      border-radius: 50%;
      position: absolute;
      left: 20px;
      top:50%;
      margin-top:-20px;
    }
  }
  .menu-area{
    display:none;
    &.mobile-menu{
      display:block;
    }
  }
  .menu-bg{
    background: #000;
    opacity: 0.7;
    position: fixed;
    top: 0;
    z-index: 90;
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
  }
  .mobile-menu{
    position:fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    .menu-list{
      position:absolute;
      top:0;
      right:0;
      background:#fff;
      width:70%;
      height:100%;
      padding:120px 0 0 45px;
      z-index:100;
      .list-item{
        margin-bottom:45px;
        a{
          font-size:16px;
          font-weight: bold;
          color:#000;
        }
      }
    }
  }
  @media (min-width: 1024px) {
    .hamburger-btn{
      display:none;
    }
    .audit-header{
      padding:0 50px;
      height:80px;
      border-bottom:1px solid #006a92;
    }
    .menu-bg{
      display:none;
    }
    .urban-nav{
      .logo{
        position:absolute;
        left:0;
        font-size: 0;
        text-indent: -9999px;
        width: 40px;
        height: 60px;
        top:50%;
        margin-top:-30px;
        background-size:100% auto;
      }
      .login-btn{
        width:60px;
        height:60px;
        margin-top:-30px;
        left:auto;
        right:0;
      }
      .logout-btn{
        width:60px;
        height:60px;
        margin-top:-30px;
        left:auto;
        right:0;
        background: #a00606;
      }
    }
    .menu-area{
      display:block;
      margin-left:auto;
    }
    .menu-list{
      display:flex;
      justify-content: center;
      position: absolute;
      right: 90px;
      top: 0;
      line-height: 80px;
      .list-item{
        a{
          font-size:16px;
          font-weight: bold;
          margin-right:30px;
        }
        &:last-child{
          a{
            margin-right:0;
          }
        }
      }
    }
  }
</style>
<template>
  <header class="audit-header">
    <nav class="urban-nav" :class="{active :topMenuOpen }">
      <h1 class="logo">
        <router-link to="/">부동산 땡처리닷컴</router-link>
      </h1>
      <button type="button" class="hamburger-btn" :class="{ active: isActive , open: topMenuOpen}" @click="menuToggle()">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </button>
      <div>
        <button type="button" class="login-btn" @click="clickLogin()" v-if="loginFlag === false" >로그인</button>
        <button type="button" class="login-btn"  v-else @click="clickMypage()">{{ this.userName }}</button>
        <div class="user-area" v-if="userInform">
          <button type="button" class="close-btn" @click="clickMypage()"><b-icon-x></b-icon-x></button>
          <div class="user">
            <span class="name">{{ this.userName }}</span>
            <div class="btns">
              <button type="button" class="btn" @click="$router.replace('/myPage')">
                <b-icon-person></b-icon-person>
                <span class="tit">마이페이지</span>
              </button>
              <button type="button" class="btn" @click="clickLogout()">
                <b-icon-arrow-bar-right></b-icon-arrow-bar-right>
                <span class="tit">로그아웃</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-area" :class="{'mobile-menu' :topMenuOpen }">
        <ul class="menu-list">
          <li class="list-item">
            <router-link to="/ViewNotice" class="menu-link">공지사항</router-link>
          </li>
          <li class="list-item">
            <router-link to="/ViewReference" class="menu-link">서식자료</router-link>
          </li>
          <li class="list-item">
            <router-link to="/ViewQuestion" class="menu-link">자주하는 질문</router-link>
          </li>
        </ul>
        <div class="menu-bg"></div>
      </div>
    </nav>
  </header>
</template>
<script>
import { mapGetters } from 'vuex'
const body = document.getElementsByTagName('body')[0]
export default {
  name: 'UrbanHeader',
  data () {
    return {
      isActive: false,
      windowWidth: window.innerWidth,
      topMenuOpen: false,
      loginFlag: false,
      userInform: false,
      userName: '',
      query: '',
      /* suggestions: [ // https://www.npmjs.com/package/vue-autosuggest#examples
           {
            id: 1,
            city: '서울시 영등포구 신길4동 209-99호',
            detail: [
              { id: 101, address: '202호' }
            ]
          },
          {
            id: 2,
            city: '서울시 영등포구 신길4동 209-99호',
            detail: [
              { id: 101, address: '202호' }
            ]
          },
          {
            id: 3,
            city: '서울시 영등포구 신길4동 209-99호',
            detail: [
              { id: 101, address: '202호' }
            ]
          },
          {
            id: 4,
            city: '고양시 일산동구 백석동 동아오츠카',
            detail: [
              { id: 202, address: '5층' }
            ]
          },
          {
            id: 5,
            city: '마산시 마산구 마산읍 32-25 추풍리', // 입력값
            detail: [
              { id: 301, address: '똘이네집 뒷마당 옆건물' } // 서브 ex 호수?
            ]
          },
          {
            id: 6,
            city: '마산시 마산구 마산읍 32-25 추풍리',
            detail: [
              { id: 301, address: '똘이네집 뒷마당 옆건물' }
            ]
          },
          {
            id: 7,
            city: '마산시 마산구 마산읍 32-25 추풍리',
            detail: [
              { id: 301, address: '똘이네집 뒷마당 옆건물' }
            ]
          },
          {
            id: 8,
            city: '마산시 마산구 마산읍 32-25 추풍리',
            detail: [
              { id: 301, address: '똘이네집 뒷마당 옆건물' }
            ]
          }
        ], */
      selected: null,
      inputProps: {
        id: 'autosuggest__input',
        placeholder: '원하시는 지역을 입력해주세요.',
        class: 'autosuggest_input'
      },
      clickItem: ''
    }
  },
  created () {
    this.loginCheck()
  },
  watch: {
    query () {
      if (this.query.length !== 0) {
        this.$store.dispatch('apiSearchList', {'keyword': this.query.replace(/ /g, ''), 'method': 'GET'})
      } else {
        this.suggestions = []
      }
    }
  },
  methods: {
    menuToggle () {
      this.isActive = !this.isActive
      this.topMenuOpen = !this.topMenuOpen
      if (this.topMenuOpen === true) {
        body.classList.add('overflow')
      } else {
        body.classList.remove('overflow')
      }
    },
    loginCheck () {
      if (sessionStorage.getItem('token') === null) {
        this.loginFlag = false
      } else {
        this.userName = sessionStorage.getItem('name')
        this.loginFlag = true
      }
    },
    clickLogout () {
      sessionStorage.clear()
      this.userInform = false
      this.loginCheck()
      alert('로그아웃 되었습니다.')
    },
    clickLogin () {
      this.$router.replace('/Login')
    },
    clickMypage () {
      this.userInform = !this.userInform
    },
    clickMove () {
      this.query = ''
      if (this.clickItem !== '') {
        sessionStorage.setItem('lat', this.clickItem.lat)
        sessionStorage.setItem('lng', this.clickItem.lng)
        if (sessionStorage.getItem('level') === null) {
          sessionStorage.setItem('level', 3)
        }
        this.clickItem = ''
        if (this.$route.path === '/SearchEstate') {
          this.$router.go('/SearchEstate')
        } else {
          this.$router.push('/SearchEstate')
        }
      } else {
        alert('지역을 다시 선택해 주세요')
      }
    },
    selectHandler (item) {
      if (item) {
        // console.log('item' + JSON.stringify(item.item))
        this.query = item.item.searcheKey
        this.clickItem = item.item
        // this.suggestions = []
        // console.log('cuerrnt = ' + JSON.stringify(this.$router.currentRoute))
        // this.selected = this.suggestion.item.detail.map(detail => detail.address).join(', ')
      }
    },
    clickHandler (item) {
      this.loading = false
    },
    blurHandler () {
      // console.log('blurHandler')
      if (this.$parent.$options.name === 'Main') {
        this.$parent.fullpageScrollStart()
      }
    },
    focusHandler () {
      // console.log('focusHandler')
      if (this.$parent.$options.name === 'Main') {
        this.$parent.fullpageScrollStop()
      }
    }
  },
  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    filteredSuggestions () {
      return [
        {
          /* data: this.suggestions.filter(item => {
              return (
                item.searcheKey
              )
            }) */
          data: this.suggestions
        }
      ]
    },
    ...mapGetters({
      suggestions: 'getSearchList'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UrbanHeader.vue